import { makeStyles } from '@material-ui/core/styles';

export const useResourceMatchPopoverStyles = makeStyles(theme => ({
  columnText: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.caption.fontSize
  },
  resourceColumn: {
    display: 'flex',
    flex: 1,
    minWidth: theme.spacing(24)
  },
  smartMatchColumn: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    minWidth: theme.spacing(12),
    color: theme.palette.text.secondary
  },
  availabilityColumn: {
    display: 'flex',
    justifyContent: 'flex-end',
    minWidth: theme.spacing(13),
    textAlign: 'right',
    color: theme.palette.text.secondary
  },
  alternativesText: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.caption.fontSize
  }
}));
